import { data } from '../../svg/Share/data';
import { makeIcon } from '../makeIcon';

export const Share = makeIcon(data, 'share', 'Share');

export default Share;
